import React from 'react';
import LegalDocument from '../components/LegalDocument';

const PrivacyPage = () => <LegalDocument ns="privacy" />;

export default PrivacyPage;
